// extracted by mini-css-extract-plugin
export default {"PoiConfirm":"PoiReportConfirmation_PoiConfirm__cfYXr"};